import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CategoryService } from '../../Services/category.service';
import { Category } from '../../Models/category';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CdkConnectedOverlay, ConnectedPosition } from "@angular/cdk/overlay";
import { Subject } from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  selectedCategory: any;
  selectedSubCategory: any;
  showDropDown = false;
  categoryHovered?: Category;
  open = false;
  seeMore = false;
  tablet = false;
  categories: {
    category: Category,
    subCategories: {
      category: Category,
      subCategories: { category: Category }[]
    }[]
  }[] = [];

  public hoveredCatId?: number | null;
  public subCategoryHoveredId?: number | null;
  destroy$ = new Subject<any>();

  @ViewChild('trigger', { static: true }) private trigger!: ElementRef;
  maxWidth?: number;

  constructor(
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private breakPointObserver: BreakpointObserver,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.categoryService.categories.subscribe((categories: Category[]) => {
      this.structureCategories(categories);
    });

    this.breakPointObserver.observe('(max-width: 1024px)').subscribe(state => {
      this.tablet = state.matches;
    });
  }

  ngAfterViewInit(): void {
    this.maxWidth = this.trigger.nativeElement.offsetWidth;
  }

  // Add handleMouseEnter function to manage hover
  handleMouseEnter(cat: any): void {
    this.selectedCategory = cat;
    this.showDropDown = true;
    this.hoveredCatId = cat.category.id!;
    this.selectedSubCategory = cat.subCategories[0];
  }

  // Helper method to organize categories into desired structure
  structureCategories(categories: Category[]): void {
    let cat: { category: Category, subCategories: { category: Category, subCategories: { category: Category }[] }[] };
    this.parentCategories(categories).forEach(e => {
      cat = { category: e, subCategories: [] };
      this.subCategories(categories, e.id!).forEach(sub => {
        const subCat: { category: Category }[] = [];
        this.subCategories(categories, sub.id!).forEach(a => subCat.push({ category: a }));
        cat.subCategories.push({ category: sub, subCategories: subCat });
      });
      this.categories.push(cat);
    });
  }

  parentCategories(categories: Category[]): Category[] {
    return categories.filter((category: Category) => category.parentId === null);
  }

  subCategories(categories: Category[], id: number): Category[] {
    return categories.filter((category: Category) => category.parentId === id);
  }

  navigate(categoryName: string, categoryId: number, subCategoryName?: string, subCategoryId?: number, subSubCat?: number) {
    categoryName = categoryName.replace(/[^a-zA-Z0-9]/g, '-');
    this.router.navigate(['/products/category', categoryId, categoryName, subCategoryId, subCategoryName], {
      queryParams: { categories: subSubCat, inStock: true }
    }).then(() => this.showDropDown = false);
  }

  navigate2(categoryName: string, categoryId: number, subCategoryName?: string, subCategoryId?: number, subSubCat?: number) {
    categoryName = categoryName.replace(/[^a-zA-Z0-9]/g, '-');
    this.router.navigate(!subCategoryId
      ? ['/products/category', categoryId, categoryName]
      : ['/products/category', categoryId, categoryName, subCategoryId, subCategoryName], {
        queryParams: { categories: subSubCat, inStock: true }
    }).then(() => this.showDropDown = false);
  }

  selectSubCat(sub: Category) {
    this.categoryHovered = sub;
    setTimeout(() => {
      if (sub === this.categoryHovered) {
        this.selectedSubCategory = sub;
      }
    }, 1500);
  }
}
